import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function Concrete() {
  return (
    <section className="imt-service-section py-5">
      <div className="container">
        <div className="row g-4">
          {/* LEFT CONTENT */}
          <div className="col-lg-8">
            <div className="imt-glass-card shadow-lg p-4">
              <div className="imt-image-frame mb-4">
                <img
                  src="images/services/DSC_1796.JPG"
                  alt="Concrete Testing"
                  className="img-fluid rounded-4"
                />
                <span className="imt-tag">IMT • Concrete Testing</span>
              </div>

              <h2 className="imt-title mb-3">Concrete Testing</h2>

              <p className="imt-body">
                IMT provides comprehensive concrete testing services to ensure
                durability, structural integrity, and compliance with ACI / ASTM
                standards. Our experienced team utilizes advanced equipment to
                deliver fast, accurate, and reliable test results that help keep
                your project on schedule and built to last.
                <br />
                <br />
                From on-site evaluations to laboratory analysis, IMT verifies
                concrete performance with precision. Whether you're validating
                mix design, batching quality, or long-term strength development,
                our testing methods ensure that the concrete used on your
                project meets critical safety and performance standards.
              </p>

              {/* CHECKLIST */}
              <div className="row mt-4">
                <div className="col-12">
                  <h4 className="imt-subtitle mb-3">
                    Concrete Testing Services
                  </h4>
                </div>

                <div className="col-md-6">
                  <ul className="imt-checklist">
                    <li>Compressive Strength Testing</li>
                    <li>Unit Weight</li>
                    <li>Grout Testing</li>
                  </ul>
                </div>

                <div className="col-md-6">
                  <ul className="imt-checklist">
                    <li>Slump Testing</li>
                    <li>Air Content</li>
                    <li>Moisture Monitoring</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT SIDEBAR */}
          <div className="col-lg-4">
            <div className="imt-sidebar">
              <div className="imt-side-nav mb-4">
                <h4 className="sidebar-title">Services</h4>
                <ul>
                  <li>
                    <a href="/soil">Soil Testing</a>
                  </li>
                  <li>
                    <a href="/geophysical">Geophysical Testing</a>
                  </li>
                  <li>
                    <a href="/concrete" className="active-link">
                      Concrete Testing
                    </a>
                  </li>
                  <li>
                    <a href="/asphalt">Asphalt Testing</a>
                  </li>
                </ul>
              </div>

              <div
                className="imt-help-box"
                style={{
                  backgroundImage: 'url("images/DSC_0202.JPG")',
                }}
              >
                <div className="inner">
                  <h3>Need Assistance?</h3>
                  <p>Speak with our testing specialists.</p>
                  <a href="tel:+18139941164" className="imt-help-number">
                    +1 (813) 994 1164
                  </a>
                  <a
                    href="/contact"
                    className="btn btn-light mt-2 imt-help-btn"
                  >
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </div>
          {/* END SIDEBAR */}
        </div>
      </div>

      {/* BACKGROUND SHAPES */}
      <div className="imt-bg-shape imt-bg-1"></div>
      <div className="imt-bg-shape imt-bg-2"></div>

      {/* CUSTOM STYLES */}
      <style>{`
        .imt-service-section {
          position: relative;
          background: #f3f3f9;
          overflow: hidden;
        }

        /* -------- GLASS CARD -------- */
        .imt-glass-card {
          background: rgba(255,255,255,0.8);
          backdrop-filter: blur(10px);
          border-radius: 18px;
          position: relative;
          z-index: 2;
        }

        /* -------- IMAGE TAG -------- */
        .imt-image-frame {
          position: relative;
        }
        .imt-tag {
          position: absolute;
          bottom: 12px;
          left: 12px;
          background: #077325;
          padding: 6px 12px;
          color: white;
          font-size: 0.8rem;
          border-radius: 5px;
          letter-spacing: 1px;
          text-transform: uppercase;
        }

        /* -------- HEADINGS -------- */
        .imt-title {
          font-size: 2.4rem;
          font-weight: 800;
          color: #077325;
          text-shadow: 1px 1px 0px #99a6c4;
        }
        .imt-subtitle {
          font-weight: 700;
          color: #077325;
        }
        .imt-body {
          font-size: 1.1rem;
          line-height: 1.7;
          color: #2d2d2d;
        }

        /* -------- CHECKLIST -------- */
        .imt-checklist li {
          list-style: none;
          margin-bottom: 10px;
          font-weight: 600;
          padding-left: 30px;
          position: relative;
        }
        .imt-checklist li::before {
          content: "✔";
          position: absolute;
          left: 0;
          top: 2px;
          font-size: 1rem;
          color: #1e66ff;
        }

        /* -------- SIDEBAR -------- */
        .imt-side-nav {
          background: white;
          border-radius: 14px;
          padding: 20px;
          box-shadow: 0 6px 18px rgba(0,0,0,0.1);
        }
        .imt-side-nav ul {
          list-style: none;
          padding-left: 0;
        }
        .imt-side-nav ul li {
          margin-bottom: 10px;
        }
        .imt-side-nav ul li a {
          text-decoration: none;
          padding: 10px 15px;
          display: block;
          border-radius: 10px;
          font-weight: 600;
          color: #001f3f;
          transition: 0.3s;
        }
        .imt-side-nav ul li a:hover {
          background: #077325;
          color: white;
        }
        .active-link {
          background: #077325 !important;
          color: white !important;
        }

        /* -------- HELP BOX -------- */
        .imt-help-box {
          background-size: cover;
          background-position: center;
          border-radius: 18px;
          padding: 40px 20px;
          margin-top: 25px;
          position: relative;
          overflow: hidden;
          box-shadow: 0 6px 20px rgba(0,0,0,0.3);
        }
        .imt-help-box::after {
          content: "";
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.55);
        }
        .imt-help-box .inner {
          position: relative;
          z-index: 2;
          color: white;
        }
        .imt-help-number {
          font-size: 1.4rem;
          display: block;
          margin-top: 5px;
          color: #ffffff;
          text-decoration: none;
        }
        .imt-help-btn {
          font-weight: bold;
          border-radius: 8px;
        }
        .imt-help-btn:hover {
          background: #077325 !important;
          color: white !important;
        }
      `}</style>
    </section>
  );
}

export default Concrete;
